//Jonas
const apiPassword = 'RjXgPOrw6P8gGUfKCMndyG&1$^%GmP&nxNJg';
const baseUrl = 'https://ricambi.totvspaulista.io:8443/webhook/10cbc8b0-1c17-48a9-b5d5-2c036fd6777b/api/';

async function verifyClient(email) {
    try {
        const response = await fetch(`${baseUrl}2023-04/customers/search.json?query=email:${email}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'apikey': apiPassword
            }
        });

        const data = await response.json();

        if (data?.customers?.length > 0) {
            return true;
        }

        return false;
    } catch (error) {
        console.error('Error:', error);
        return false;
    }
}

function isValidPassword(password) {

    if (password.length < 8) {
        return false;
    }


    const hasUpperCase = /[A-Z]/.test(password);
    if (!hasUpperCase) {
        return false;
    }


    const hasLowerCase = /[a-z]/.test(password);
    if (!hasLowerCase) {
        return false;
    }


    const hasNumber = /\d/.test(password);
    if (!hasNumber) {
        return false;
    }


    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    if (!hasSpecialChar) {
        return false;
    }


    return true;
}

function formatCNPJ(cnpjField) {
    const cnpj = cnpjField.value.replace(/\D/g, '');

    if (cnpj.length <= 2) {
        cnpjField.value = cnpj;
    } else if (cnpj.length <= 5) {
        cnpjField.value = `${cnpj.slice(0, 2)}.${cnpj.slice(2)}`;
    } else if (cnpj.length <= 8) {
        cnpjField.value = `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(5)}`;
    } else if (cnpj.length <= 12) {
        cnpjField.value = `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(5, 8)}/${cnpj.slice(8)}`;
    } else {
        cnpjField.value = `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(5, 8)}/${cnpj.slice(8, 12)}-${cnpj.slice(12, 14)}`;
    }
}

function formatPhoneSend(phoneField) {
    if (!phoneField) return;
    let cleaned = phoneField?.value.replace(/[^\d]/g, '');
    let formatted = '+55.' + cleaned;

    return formatted;
}

function formatPhone(phoneField) {
    if (!phoneField) return;
    const phone = phoneField.value.replace(/\D/g, '');

    if (phone.length > 2 && phone[2] === '9') {
        phoneField.maxLength = 15; // Set maxlength to 14 if the first digit after the area code is 9
    } else {
        phoneField.maxLength = 14; // Set maxlength to 15 otherwise
    }

    if (phone.length <= 2) {
        phoneField.value = `(${phone}`;
    } else if (phone.length <= 6) {
        phoneField.value = `(${phone.slice(0, 2)}) ${phone.slice(2)}`;
    } else if (phone.length <= 10) {
        phoneField.value = `(${phone.slice(0, 2)}) ${phone.slice(2, 6)}-${phone.slice(6)}`;
    } else if (phone[2] === '9' && phone.length <= 11) {
        phoneField.value = `(${phone.slice(0, 2)}) ${phone.slice(2, 7)}-${phone.slice(7)}`;
    } else {
        phoneField.value = `(${phone.slice(0, 2)}) ${phone.slice(2, 6)}-${phone.slice(6)}`;
    }
}

// Função para verificar CPF
async function verifyClientByCPF(cpf) {
    try {
        const namespace = 'custom';
        const key = 'cpf';

        const response = await fetch(
            `${baseUrl}2023-04/customers/search.json?query=metafield:${namespace}.${key}:${cpf}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'apikey': apiPassword
                }
            }
        );

        const data = await response.json();

        if (data?.customers?.length > 0) {
            console.log('Cliente encontrado com este CPF:', data.customers[0].id);
            return true;
        }

        return false;
    } catch (error) {
        console.error('Erro ao verificar CPF:', error);
        return false;
    }
}

// Função para verificar CNPJ
async function verifyClientByCNPJ(cnpj) {
    try {   
        const namespace = 'custom';
        const key = 'cnpj';

        const response = await fetch(
            `${baseUrl}2023-04/customers/search.json?query=metafield:${namespace}.${key}:${cnpj}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'apikey': apiPassword
                }
            }
        );

        const data = await response.json();

        if (data?.customers?.length > 0) {
            console.log('Cliente encontrado com este CNPJ:', data.customers[0].id);
            return true;
        }

        return false;
    } catch (error) {
        console.error('Erro ao verificar CNPJ:', error);
        return false;
    }
}

function displayMessage(message, type = 'info') {
    // 1. Remove qualquer modal antigo que ainda esteja aberto
    const existingModal = document.getElementById('custom-modal-overlay');
    if (existingModal) {
        existingModal.remove();
    }

    // 2. Cria a camada de fundo escuro (Overlay)
    const overlay = document.createElement('div');
    overlay.id = 'custom-modal-overlay';
    overlay.className = 'modal-overlay';

    // Define a cor do texto/borda com base no tipo ('error', 'success', etc)
    const borderColor = type === 'error' ? '#d9534f' : '#28a745';

    // 3. Monta a estrutura HTML do Modal
    overlay.innerHTML = `
        <div class="modal-box" style="border-top: 5px solid ${borderColor};">
            <button class="modal-close-btn" id="closeModalBtn">&times;</button>
            <div class="modal-content">
                <p>${message}</p>
            </div>
            <div class="modal-actions">
                <button class="modal-ok-btn" id="okModalBtn">OK</button>
            </div>
        </div>
    `;

    // 4. Adiciona o modal ao corpo da página
    document.body.appendChild(overlay);

    // 5. Função interna para fechar o modal
    const closeModal = () => {
        overlay.classList.add('fade-out');
        setTimeout(() => overlay.remove(), 200); // Remove do DOM após a animação
    };

    // 6. Eventos para fechar (clique nos botões ou fora do modal)
    document.getElementById('closeModalBtn').addEventListener('click', closeModal);
    document.getElementById('okModalBtn').addEventListener('click', closeModal);

    // Fecha se o usuário clicar fora do quadro do modal
    overlay.addEventListener('click', (event) => {
        if (event.target === overlay) {
            closeModal();
        }
    });
}

function togglePasswordVisibility(inputId, iconElement) {
    const passwordInput = document.getElementById(inputId);

    if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
    } else {
        passwordInput.type = 'password';
    }
}

document.getElementById('cep')?.addEventListener('input', function (e) {
    console.log('nao foi');

    let cep = e.target.value.replace(/\D/g, ''); // Remove caracteres não numéricos

    cep = cep.substring(0, 8); // Limita a 8 caracteres

    if (cep.length > 5) {
        cep = cep.replace(/(\d{5})(\d{0,3})/, '$1-$2'); // Formata para XXXXX-XXX
    }

    e.target.value = cep;
});


function validarCNPJ(cnpj) {
    // Remove tudo que não for número
    cnpj = cnpj.replace(/[^\d]+/g, '');

    // Verifica se tem 14 dígitos
    if (cnpj.length !== 14) return false;

    // Elimina CNPJs inválidos conhecidos (ex: 11111111111111)
    if (/^(\d)\1+$/.test(cnpj)) return false;

    // Validação dos dígitos verificadores
    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
    }

    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != digitos.charAt(0)) return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != digitos.charAt(1)) return false;

    return true;
}
